exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group[data-v-870e1ed2]{\n  border-top: 1px solid #dadada;\n}\n", ""]);

// exports
